module.exports = __webpack_public_path__ + "static/media/PracticeDemo2.1853a152.jpg";